import Translate from './pages/Translate';
import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect } from 'react';

import LoadingOverlay from './components/LoadingOverlay';
import { useSyncAuth0AccessToken } from './hooks/useSyncAuth0AccessToken';
import { useSyncChromeStorage } from './hooks/useExtensionStorage';
import { useStore } from './store/store';

const App = () => {
	const { isLoading: isAuth0Loading } = useAuth0();
	const { isTokenLoading } = useSyncAuth0AccessToken();
	const { auth0TokenId, selectedConsumerId, initialTextToTranslate, consumerLocales, autoDetectLang, fetchLanguagesByConsumer, setAutoTranslate, setIsFromAutoDetect, setLoading } = useStore(state => state);

	useSyncChromeStorage();

	/**
	 * Effect for initializing the detected language
	 */
	useEffect(() => {
		if (auth0TokenId && selectedConsumerId && consumerLocales.length === 0) {
			fetchLanguagesByConsumer(auth0TokenId, selectedConsumerId).then(() => {
				if (initialTextToTranslate) {
					autoDetectLang(initialTextToTranslate, auth0TokenId, selectedConsumerId).then(() => {
						setAutoTranslate(true);
						setIsFromAutoDetect(true);
						setLoading(true);
					});
				}
			});
		} else {
			if (auth0TokenId && selectedConsumerId && initialTextToTranslate) {
				autoDetectLang(initialTextToTranslate, auth0TokenId, selectedConsumerId).then(() => {
					setAutoTranslate(true);
					setIsFromAutoDetect(true);
					setLoading(true);
				});
			}
		}

	}, [auth0TokenId, selectedConsumerId, initialTextToTranslate]);

	if (isAuth0Loading || isTokenLoading) {
		return <LoadingOverlay />
	}

	return (
		<div className="app">
			<Translate />
		</div>
	);

};

export default App;
